var _path, _path2, _rect, _rect2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGasolina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1884 16.113L10.9567 14.0603L10.4903 13.2828L10.0238 14.0603L8.79214 16.113L8.64847 16.4183C8.01315 17.7684 8.99818 19.3206 10.4903 19.3206C11.9823 19.3206 12.9674 17.7684 12.332 16.4183L12.1884 16.113ZM10.4903 14.8378L9.49885 16.4901L9.37232 16.759C8.9867 17.5784 9.58459 18.5206 10.4903 18.5206C11.3959 18.5206 11.9938 17.5784 11.6082 16.759L11.4817 16.4901L10.4903 14.8378Z",
    fill: "#D91F05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70752 2C1.70752 1.17157 2.37909 0.5 3.20752 0.5H17.3207C18.1492 0.5 18.8207 1.17157 18.8207 2V23.6509H1.70752V2Z",
    stroke: "#D91F05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.72644,
    y: 4.12256,
    width: 11.0755,
    height: 5.03774,
    rx: 1,
    stroke: "#D91F05"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 23.4434,
    width: 19.5283,
    height: 3.83019,
    rx: 1.91509,
    stroke: "#D91F05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0471 12.4906L24.0471 8.01572L25.397 6.21593L31.4999 12.8737V13.9906H25.5471C24.7187 13.9906 24.0471 13.319 24.0471 12.4906Z",
    stroke: "#D91F05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4999 18.1131H21.5471C22.6517 18.1131 23.5471 19.0086 23.5471 20.1131V21.7358C23.5471 24.07 25.4394 25.9622 27.7735 25.9622V25.9622V25.9622C29.7743 25.9622 31.3962 24.3403 31.3962 22.3395V13.8867",
    stroke: "#D91F05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1314 8.03533L20.6158 5.49719C20.1163 5.13655 20.0037 4.43924 20.3644 3.93971C20.725 3.44019 21.4223 3.3276 21.9218 3.68824L25.4374 6.22638L24.1314 8.03533Z",
    stroke: "#D91F05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasolina);
export default __webpack_public_path__ + "static/media/gasolina.869bb67dba6717e2598b2600a509bacc.svg";
export { ForwardRef as ReactComponent };